import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

import { PageTitleBarService } from './page-title-bar.service';

import { SlotComponent } from '@iss/core/utils';

@Component({
  selector: 'iss-page-title-bar',
  templateUrl: './page-title-bar.component.html',
  styleUrls: [ './page-title-bar.component.scss' ],
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    SlotComponent,
  ],
})
export class PageTitleBarComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly service = inject(PageTitleBarService);
  private readonly cdr = inject(ChangeDetectorRef);
  public template: TemplateRef<unknown> | null = null;

  public ngOnInit(): void {
    this.service.template$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(template => {
      this.template = template;
      this.cdr.markForCheck();
    });
  }

  public get title(): string {
    return window.document.title;
  }
}
